<script lang="ts">
  import Button from "../../components/atoms/Button.svelte";
  import Estimation from "../../components/molecules/Estimation.svelte";
  import ZipCode from "../../components/molecules/ZipCode.svelte";
  import useMovingFlow from "../../providers/useMovingFlow";

  const { state, send } = useMovingFlow();
  let showResidenceError = false;
  let showZipCodeError = false;
  let facilityInformation = { ...$state.context.facilityInformation };
  let zipCodeValid = false;

  let inputEstimationValue = $state.context.estimation > 0 ? $state.context.estimation : 20000;
  let ableToContinue = zipCodeValid && inputEstimationValue > 0;
  let hasPressedContinue = false;

  $: if (
    inputEstimationValue != undefined &&
    facilityInformation.residenceType &&
    facilityInformation.zipcode !== undefined
  ) {
    ableToContinue =
      zipCodeValid && inputEstimationValue > 0 && !!facilityInformation.residenceType;
  } else {
    ableToContinue = false;
  }

  $: if (zipCodeValid) {
    showZipCodeError = false;
  }

  const onClickNext = () => {
    if (ableToContinue) {
      send("SET_ESTIMATION", { data: { estimation: inputEstimationValue } });
      send("SET_ZIP_CODE", {
        data: {
          zipcode: facilityInformation.zipcode ? facilityInformation.zipcode.toString() : "",
        },
      });
      send("SET_RESIDENCE_TYPE", { data: { residenceType: facilityInformation.residenceType } });
      if ($state.context.sentFromWidget) {
        send("INFORMATION");
      } else {
        send("NEXT");
      }
    } else {
      if (!facilityInformation.residenceType) {
        showResidenceError = true;
      }
      if (!zipCodeValid) {
        showZipCodeError = true;
      }
    }
  };
</script>

<form on:submit|preventDefault={onClickNext} class=" ">
  <Estimation
    residenceText="Jag flyttar till "
    bind:hasPressedContinue
    bind:inputEstimationValue
    bind:residenceType={facilityInformation.residenceType}
  >
    <span slot="heading">Hur stor är din nya boyta?</span>
    <span slot="text"
      >För att få ett ungefärligt pris behöver du uppskatta din årliga elförbrukning.</span
    >
  </Estimation>
  <ZipCode
    bind:hasPressedContinue
    bind:valid={zipCodeValid}
    bind:zipcode={facilityInformation.zipcode}
  >
    2. Fyll i ditt postnummer och klicka på ”beräkna pris” för att se din beräknade månadskostnad.
  </ZipCode>
  <Button
    type={"submit"}
    onClick={() => {
      hasPressedContinue = true;
    }}
    disabled={$state.context.purchaseFlowType == "v1" ? !ableToContinue : false}
    animate={false}
    class="w-full mt-5">Beräkna pris</Button
  >
</form>
